import { Optional, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '.';

@Pipe({
    name: 'translate',
})

export class TranslatePipe implements PipeTransform {

    constructor( @Optional() public _translate: TranslateService) { }

    transform(value: string, args: any): any {
        if (!value) {
            return;
        }
        return this._translate?.instant(value, args ?? null);
    }
}
